import type { FC } from 'react';

import styles from './Separator.module.scss';

const Separator: FC = () => {
  return <hr className={styles.separator} />;
};

export { Separator };
